import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';

import { PeopleIcon, RobotIcon } from '@app-velocity/icons';

const StyledDetails = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(4),
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  gap: theme.spacing(1),
}));

export const Stats = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const Stat = styled('div')(({ theme }) => ({
  gap: theme.spacing(1),
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  fontSize: 12,
  fontWeight: 700,
  color: '#7a7a7a',
  svg: {
    fill: '#7a7a7a',
    width: 14,
  },
}));

const ViewName = styled(Typography)({
  fontWeight: 700,
  fontSize: 14,
});

export type ViewDetailsProps = {
  name: string;
  humanParticipants: number;
  simulatedParticipants: number;
};

export const ViewDetails = ({
  name,
  humanParticipants,
  simulatedParticipants,
}: ViewDetailsProps) => {
  return (
    <StyledDetails>
      <ViewName>{name}</ViewName>
      <Stats>
        {humanParticipants ? (
          <Stat>
            {humanParticipants}
            <PeopleIcon />
          </Stat>
        ) : null}
        {simulatedParticipants ? (
          <Stat>
            {simulatedParticipants}
            <RobotIcon />
          </Stat>
        ) : null}
      </Stats>
    </StyledDetails>
  );
};
